export default "__VITE_ASSET__215a9c6f__"